import { render, staticRenderFns } from "./parseTicket.vue?vue&type=template&id=a87e5572&scoped=true"
import script from "./parseTicket.vue?vue&type=script&lang=js"
export * from "./parseTicket.vue?vue&type=script&lang=js"
import style0 from "./parseTicket.vue?vue&type=style&index=0&id=a87e5572&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87e5572",
  null
  
)

export default component.exports